import axios from '../config/axios'

const API_BASE = '/trip-contracts'

const tripContractService = {
  // Get all trip contracts with pagination and filtering
  getAll: (filters = {}) => {
    return axios.get(API_BASE, { params: filters })
  },

  // Get single trip contract with related data
  getOne: (tripId) => {
    return axios.get(`${API_BASE}/${tripId}`, {
      params: {
        include_payments: 'true'
      }
    })
  },

  // Create new trip contract
  create: (data) => {
    return axios.post(API_BASE, data)
  },

  // Update trip contract
  update: (tripId, data) => {
    return axios.put(`${API_BASE}/${tripId}`, data)
  },

  // Delete trip contract
  delete: (tripId) => {
    return axios.delete(`${API_BASE}/${tripId}`)
  },

  // Add single payment to a trip
  addPayment: (tripId, paymentData) => {
    return axios.post(`${API_BASE}/${tripId}/payments`, paymentData)
  },

  // Get payment history for a trip
  getPayments: (tripId) => {
    return axios.get(`${API_BASE}/${tripId}/payments`)
  },

  // Batch payment across multiple trips for a contract party
  batchPayment: (partyId, paymentData) => {
    return axios.post(`${API_BASE}/party/${partyId}/batch-payment`, paymentData)
  },

  // Get all outstanding trips for a contract party
  getPartyTrips: (partyId, filters = {}) => {
    return axios.get(`${API_BASE}/party/${partyId}/trips`, { params: filters })
  },

  // Download invoice PDF
  downloadInvoice: (tripId) => {
    return axios.get(`${API_BASE}/${tripId}/invoice/download`, {
      responseType: 'blob'
    })
  }
}

export default tripContractService
